import { render, staticRenderFns } from "./csvPreview.vue?vue&type=template&id=fed4449a&scoped=true&"
import script from "./csvPreview.vue?vue&type=script&lang=js&"
export * from "./csvPreview.vue?vue&type=script&lang=js&"
import style0 from "./csvPreview.vue?vue&type=style&index=0&id=fed4449a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed4449a",
  null
  
)

export default component.exports